import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import { IconsService, LanguagePickerComponent } from '@rieaya-core';
import { TranslocoModule } from '@jsverse/transloco';
import { RouterLinkFactory } from '../../../../core/router/router-link-factory';
import { filter, Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';
import {
  LANG,
  LAUNDRY_MANAGER,
  USER_DATA,
} from '../../../../core/utils/constant';
import { NotificationsComponent } from '../notifications/notifications.component';

@Component({
  selector: 'app-header',
  imports: [
    ButtonModule,
    CommonModule,
    RouterModule,
    LanguagePickerComponent,
    TranslocoModule,
    BreadcrumbModule,
    UserAvatarComponent,
    NotificationsComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent implements OnInit, OnDestroy {
  icons = inject(IconsService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private routerLinks = inject(RouterLinkFactory);

  @Input() isMenuOpen = false;

  @Output() sidebarToggled = new EventEmitter<void>(); // Event to notify parent

  items: MenuItem[] = [];
  home: MenuItem = {
    label: 'shared/home',
    icon: this.icons.home,
    routerLink: this.routerLinks.homepage()[0],
  };

  userData = JSON.parse(localStorage.getItem(USER_DATA) || '{}') ?? '';

  LAUNDRY_MANAGER = LAUNDRY_MANAGER;

  LANG = LANG;

  private _subs: Subscription[] = [];

  toggleSidebar() {
    this.sidebarToggled.emit(); // Emit event on button click
  }

  ngOnInit() {
    // أول مرة يدخل فيها المستخدم أو يعمل refresh
    this.updateBreadcrumbs();

    this._subs.push(
      // لما يتنقل بين الصفحات في نفس الجلسة
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => {
          this.updateBreadcrumbs();
        })
    );
  }

  private updateBreadcrumbs() {
    this.items = this.buildBreadcrumbs(this.activatedRoute.root);
  }

  private buildBreadcrumbs(
    route: ActivatedRoute,
    breadcrumbs: MenuItem[] = []
  ): MenuItem[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const breadcrumbData = child.snapshot.data['breadcrumbs'];

      if (breadcrumbData) {
        breadcrumbs = breadcrumbData.map((bc: any) => {
          let parsedLink = bc.link;

          // ✅ استبدال كل params اللي موجودة بالـ route
          Object.keys(child.snapshot.params).forEach((paramKey) => {
            const paramValue = child.snapshot.params[paramKey];
            parsedLink = parsedLink.replace(`:${paramKey}`, paramValue);
          });

          // ✅ إضافة / إذا مش موجود
          if (!parsedLink.startsWith('/')) {
            parsedLink = '/' + parsedLink;
          }

          return {
            label: bc.label,
            routerLink: parsedLink.split('/').filter((p: any) => p !== ''),
          };
        });
      }

      return this.buildBreadcrumbs(child, breadcrumbs);
    }

    return breadcrumbs;
  }

  formatRouterLink(link: string[] | undefined): string[] {
    if (!link) return this.routerLinks.homepage();
    return link;
  }

  ngOnDestroy(): void {
    this._subs.forEach((sub) => sub.unsubscribe());
  }
}
